import { render, staticRenderFns } from "./CalendarControlWaitingRoom.vue?vue&type=template&id=67a88817&scoped=true"
import script from "./CalendarControlWaitingRoom.vue?vue&type=script&lang=js"
export * from "./CalendarControlWaitingRoom.vue?vue&type=script&lang=js"
import style0 from "./CalendarControlWaitingRoom.vue?vue&type=style&index=0&id=67a88817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a88817",
  null
  
)

export default component.exports